export const DASHBOARD_URL: string = 'https://dashboard.learnandearn.school';
export const IXL_PRACTICE_SUMMARY_REQUEST_PATH: string = '/practice/summary';
export const IXL_SAVE_QUIZ_RESPONSE_REQUEST_PATH: string = '/quiz/saveQuizResponse';
